import { Link } from "react-router-dom";
import { Ban } from "lucide-react";
import { Button } from "@/components/ui/button";
import { LegalFooter } from "@/components/LegalFooter";

export default function CancellationPolicy() {
  return (
    <div className="min-h-screen bg-background px-4 sm:px-6 py-8 flex flex-col">
      <div className="mx-auto w-full max-w-4xl space-y-6 flex-1">
        <div className="flex items-center justify-between gap-3">
          <Button variant="outline" size="sm" asChild>
            <Link to="/">Back to Workshop</Link>
          </Button>
        </div>

        <section className="glass-panel rounded-3xl p-6 sm:p-8">
          <div className="flex items-center gap-4">
            <div className="grid h-12 w-12 place-items-center rounded-xl bg-primary/10">
              <Ban className="w-6 h-6 text-primary" />
            </div>
            <div>
              <h1 className="text-2xl font-semibold text-foreground">Cancellation Policy</h1>
              <p className="text-sm text-muted-foreground mt-2">
                Some items in our store may be offered to you as a subscription, a pre-order, or try before you buy.
                This cancellation policy lays out how you can change or cancel these kinds of purchases.
              </p>
            </div>
          </div>
        </section>

        <section className="glass-panel rounded-2xl p-6 space-y-4">
          <h2 className="text-base font-medium text-foreground">Subscriptions</h2>
          <p className="text-sm text-muted-foreground">
            When you purchase a subscription you'll receive repeat deliveries. These are based on the subscription
            duration and frequency that you select.
          </p>
          <p className="text-sm text-muted-foreground">
            Your payment details will be stored securely and you'll be charged for each of these deliveries, unless
            you choose to pay in advance.
          </p>
          <p className="text-sm text-muted-foreground">
            Some subscriptions may auto-renew at the end of their duration. If you don't want to renew a
            subscription you can cancel it.
          </p>
          <p className="text-sm text-muted-foreground">
            If you want to cancel or change your subscription, you can do it at any time. Your order confirmation
            emails have links to your order. You can manage your subscription from there.
          </p>
          <p className="text-sm text-muted-foreground">
            See our returns policy for more details on returns and refunds.
          </p>
        </section>
      </div>
      <LegalFooter />
    </div>
  );
}
